module.exports = __webpack_public_path__ + "media/1.a400b2cb.mp4";